module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchandises) ? _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isWapp) ? _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [_c('span', {
    staticClass: "icon icon-left goback",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "goback"
  }, _vm._l((_vm.merchandises._titleList), function(title, index) {
    return _c('span', {
      staticStyle: {
        "margin-left": ".5rem"
      }
    }, [(index <= 1) ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "searchbar title searchbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-row",
    staticStyle: {
      "margin-top": "2.5rem",
      "margin-bottom": "3rem"
    }
  }, [_c('a', {
    staticClass: "tab-link active button",
    staticStyle: {
      "border-bottom": "1px solid",
      "color": "#0894ec",
      "background-color": "transparent"
    },
    attrs: {
      "id": "detail",
      "href": "#tab-detail"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(1)
      }
    }
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "introduce",
      "href": "#tab-introduce"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(2)
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "qualityCommitment",
      "href": "#tab-qualityCommitment"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(3)
      }
    }
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "comments",
      "href": "#tab-comments"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(4)
      }
    }
  }, [_vm._v("评论(0)")]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "tlnoImg",
      "href": "#tab-tlnoImg"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(5)
      }
    }
  }, [_vm._v("载体图谱")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('header', [_c('div', {
    staticClass: "buttons-row",
    staticStyle: {
      "margin-top": "2.5rem",
      "margin-bottom": "3rem"
    }
  }, [_c('a', {
    staticClass: "tab-link active button",
    staticStyle: {
      "border-bottom": "1px solid",
      "color": "#0894ec",
      "background-color": "transparent",
      "margin-top": "-40px"
    },
    attrs: {
      "id": "detail",
      "href": "#tab-detail"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(1)
      }
    }
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "introduce",
      "href": "#tab-introduce"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(2)
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "qualityCommitment",
      "href": "#tab-qualityCommitment"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(3)
      }
    }
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "comments",
      "href": "#tab-comments"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(4)
      }
    }
  }, [_vm._v("评论(0)")]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "tlnoImg",
      "href": "#tab-tlnoImg"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(5)
      }
    }
  }, [_vm._v("载体图谱")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin-top": "2rem"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [(_vm.merchandises.specialAnnouncement) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：" + _vm._s(_vm.merchandises.specialAnnouncement) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.soldOut) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：该产品已售罄，具体上线时间可咨询在线客服。\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showExtraMessage) ? _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "margin-left": "1rem"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec",
      "margin-left": "1rem"
    }
  }, [(_vm.filteredShowPromotions && _vm.filteredShowPromotions.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n              "), _vm._l((_vm.filteredShowPromotions), function(proo, index) {
    return _c('div', [_c('span', [_vm._v(_vm._s(index + 1) + ": " + _vm._s(proo.description))])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    style: ({
      'margin-top': '-.75rem',
      'margin-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '35px'
    })
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab-detail"
    }
  }, [_c('div', {
    staticClass: "list-block"
  }, [(_vm.merchandises.categoryId === 20) ? _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.groupId === 1) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "0.7rem",
      "margin-right": "0.1rem",
      "border": "0.5px solid #e7e7e7"
    }
  }), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.value !== null && attribute.groupId === 2) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.groupId === 3) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "param:": _vm.$route.params.merchandises,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.merchandises.priceMax !== undefined) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMax)))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.price)))])])]), _vm._v(" "), (_vm.merchandises.priceMin !== undefined) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("科研终端用户优惠价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMin)))])])]) : _vm._e(), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.secPromotionRatio) + "折")])])]) : _vm._e()], 2) : _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== '' && attribute.value !== '214' && attribute.columnName !== 'GeneInfo') ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMax)))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMin)))])])]), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [(_vm.secPromotionDetail && _vm.secPromotionDetail.seckillType === 1) ? _c('span', [_vm._v("¥" + _vm._s(((1 - _vm.secPromotionDetail.seckilltRatio) * _vm.merchandises.priceMin).toFixed(2)))]) : _vm._e()])])]) : _vm._e()], 2), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-introduce"
    }
  }, [(_vm.merchandises.H5FileName && _vm.introduces) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduces)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.merchandises.H5FileName && _vm.merchandises.description) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "10.5pt",
      "line-height": "2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.merchandises.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.merchandises.manualFileName) ? _c('div', [(_vm.merchandises.manualFileName.split(';').length === 1) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "#0A7CE3"
    },
    on: {
      "click": function($event) {
        return _vm.gotomanual(_vm.merchandises.manualFileName)
      }
    }
  }, [_vm._v("查看商品手册")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.merchandises.manualFileName.split(';')), function(manualFileName, index) {
    return (_vm.merchandises.manualFileName.split(';').length !== 1) ? _c('div', [_c('div', {
      staticStyle: {
        "color": "#0A7CE3"
      },
      on: {
        "click": function($event) {
          return _vm.gotomanual(manualFileName)
        }
      }
    }, [_vm._v("查看商品手册" + _vm._s(index + 1))])]) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-qualityCommitment"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qualityCommitment)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.Comments.length > 0) ? _c('ul', _vm._l((_vm.Comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(comment.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(comment.createDT.split(' ')[0]))])]), _vm._v(" "), _c('div', _vm._l((comment.commentLevel), function(index) {
      return _c('span', {
        staticClass: "icon icon-star star",
        staticStyle: {
          "background-color": "yellow",
          "margin-left": "0.2rem"
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(comment.comments))])])])])
  }), 0) : _c('div', [_vm._v("\n                  暂无用户评价！\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-tlnoImg"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.tlnoimgurl !== '') ? _c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.tlnoimgurl
    }
  })]) : _c('div', [_vm._v("\n                   无载体！\n                ")])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('span', {
    on: {
      "click": _vm.gotoCart
    }
  }, [_c('span', {
    staticClass: "icon icon-cart",
    staticStyle: {
      "margin-right": "100px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "margin-left": "-47px"
    }
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()])]), _vm._v(" "), (_vm.isWapp) ? _c('span', [(_vm.QuoteStatus === false && _vm.merchandises.priceMin > 0) ? _c('section', {
    staticClass: "gotopay"
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    },
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("加入购物车")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    }
  }, [_vm._v("加入购物车")])])]) : _c('span', [(_vm.QuoteStatus === false && _vm.merchandises.priceMin > 0) ? _c('section', {
    staticClass: "gotopay"
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    },
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("加入购物车")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    }
  }, [_vm._v("加入购物车")])])])])])]) : _c('div', {
    staticStyle: {
      "margin-top": "11rem",
      "text-align": "center",
      "font-size": "200%"
    }
  }, [_c('div', [_vm._v("\n      此商品已经下架！\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title-row"
  }, [_c('span', {
    staticStyle: {
      "color": "#ff3f3f",
      "font-size": "0.6rem",
      "margin-left": "0.5rem"
    }
  }, [_vm._v("注：本产品需回款后才能发货")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v("产品规格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "background-color": "#E1E1E4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".4rem",
      "margin-left": ".5rem",
      "color": "gray"
    }
  }, [_vm._v("\n\n                    不同产品分装规则说明\n                    "), _c('div', [_vm._v("\n                      1.菌液:200μL/tube*1\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      2.质粒:不分装\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      3.慢病毒:50μL/tube\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      4.腺病毒:200μL/tube\n                    ")]), _c('div', [_vm._v("\n                    5.逆转录病毒:50μL/tube\n                  ")]), _vm._v(" "), _c('div', [_vm._v("\n                      6.腺相关病毒:50μL/tube\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/user.jpg",
      "width": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35070632","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/finder/detail/finderMerchandiseDeail.vue
// module id = 1596
// module chunks = 8